var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('erji-title',{attrs:{"titleName":this.titleName,"fatherName":this.fatherName}}),_c('div',{staticClass:"erji-content"},[_c('list',{attrs:{"listId":this.childId,"page":this.page}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }